import React, { useContext } from 'react'
import { useQuery } from '@apollo/react-hooks'
import get from 'lodash/get'
import { Col } from 'antd'

import Portfolio from '../Portfolio'
import { AppContext } from 'AppContext'
import { GET_DASHBOARD_SIP_AMC } from 'modules/Dashboard/graphql/Queries'

export default function () {
  const { state: { selectedGroup, selectedStrategy } } = useContext(AppContext)
  const { data, loading } = useQuery(GET_DASHBOARD_SIP_AMC, { variables: { where: { groupId: selectedGroup, strategyCode: selectedStrategy } }, fetchPolicy: 'network-only' })
  if (loading || !get(data, 'spDashbordSIPAMC') || !get(data, 'spDashbordSIPAMC')[0] || !get(data, 'spDashbordSIPAMC')[1]) return <></>

  return (
    <>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <Portfolio type='AMC' {...get(data, 'spDashbordSIPAMC')[1]} />
      </Col>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <Portfolio {...get(data, 'spDashbordSIPAMC')[0]} />
      </Col>
    </>
  )
}
